import { render } from "./HelpDocumentModalComponent.vue?vue&type=template&id=60637eaa&scoped=true"
import script from "./HelpDocumentModalComponent.vue?vue&type=script&lang=js"
export * from "./HelpDocumentModalComponent.vue?vue&type=script&lang=js"

import "./HelpDocumentModalComponent.vue?vue&type=style&index=0&id=60637eaa&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60637eaa"]])

export default __exports__